export function getBodyScrollbarWidth(): number {
  return window.innerWidth - document.documentElement.offsetWidth
}

export function lockBodyScroll() {
  document.body.style.paddingRight = getBodyScrollbarWidth() + 'px'
  document.body.style.overflow = 'hidden'
}

export function unlockBodyScroll() {
  document.body.style.paddingRight = ''
  document.body.style.overflow = ''
}
